import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import { ProductInfo } from 'components/Pages/Configurator/Popup/ProductList/ProductInfo';
import { ConfiguratorProductTypeSummed } from 'types/configurator';

type ProductListRowProps = {
    product: ConfiguratorProductTypeSummed;
};

export const ProductListRow: FC<ProductListRowProps> = ({ product }) => {
    return (
        <div className="grid grid-cols-4 rounded-md pb-8 vl:pb-12">
            <div className="col-span-4 flex w-full items-center justify-start gap-x-4 vl:col-span-3 vl:gap-x-8">
                <div className="flex h-20 max-h-[80px] w-20 min-w-[80px] items-center justify-center">
                    <Image
                        alt={product.name}
                        className="max-h-[80px]"
                        height="80"
                        src={product.mainImage?.url ?? null}
                        width="80"
                    />
                </div>

                <div className="block w-full text-body font-normal leading-5 tracking-wider text-primary [word-break:break-word]">
                    <ExtendedNextLink
                        className="text-primary no-underline hover:text-grayDark"
                        href={product.slug}
                        type="product"
                    >
                        <>{product.name}</>
                    </ExtendedNextLink>

                    <ProductInfo
                        catalogNumber={product.catalogNumber}
                        className="block vl:hidden"
                        quantity={product.quantity}
                    />
                </div>
            </div>

            <ProductInfo
                catalogNumber={product.catalogNumber}
                className="hidden vl:block"
                quantity={product.quantity}
            />
        </div>
    );
};
